<mat-toolbar class="topbar" *ngIf="isTauri" style="position: fixed; top: 0; background: transparent">
  <span class="flex-1-auto"></span>
  <button mat-icon-button aria-label="Réduire" matTooltip="Réduire l'application" class="d-flex justify-content-center" (click)="doMinimizeApp()">
    <i-tabler name="window-minimize" style="color: #073869;" class="icon-24 d-flex"></i-tabler>
  </button>

  <button mat-icon-button aria-label="Quitter" matTooltip="Quitter l'application" class="d-flex justify-content-center" (click)="doQuitApp()">
    <i-tabler name="square-rounded-x-filled"  style="color: #073869;" class="icon-24 d-flex"></i-tabler>
  </button>
</mat-toolbar>

<div class="blank-layout-container justify-content-center">
    <div class="position-relative row w-100 h-100">
        <div class="col-lg-12 col-xl-4 p-0">
            <div class="p-32 d-flex align-items-start align-items-lg-center justify-content-center h-100" style="box-shadow : rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;">

                <div class="row justify-content-center w-100">
                    <div class="col-lg-12 max-width-form">
                        <div class="text-center">
                            <img src="assets/images/logos/cc-logo-noBG-min.png" alt="logo" style="width: 100%; max-width: 260px; margin: auto;">
                            <h4 class="f-w-700 f-s-24 m-0">Bienvenue sur votre plateforme</h4>
                            <span class="f-s-14 d-block mat-body-1 m-t-8">Authentification</span>
                        </div>

                        <form class="m-t-30" [formGroup]="form" (ngSubmit)="submit()">
                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Interface</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <mat-select formControlName="Interface">
                                    <mat-option [value]="CLU_MOBILE_INTERFACE.FRONTOFFICE">Frontoffice</mat-option>
                                    <mat-option [value]="CLU_MOBILE_INTERFACE.BACKOFFICE">Backoffice</mat-option>
                                </mat-select>
                                <mat-hint *ngIf="f['Interface'].touched && f['Interface'].invalid" class="m-b-16 error-msg">
                                    <div class="text-error" *ngIf="f['Interface'].errors && f['Interface'].errors['required']">
                                        L'interface est requise
                                    </div>
                                </mat-hint>
                            </mat-form-field>
                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Domaine</mat-label>
                            <mat-form-field id="domaine_field" appearance="outline" class="w-100" color="primary">
                                <input matInput formControlName="Domaine" />
                                <div style="position: absolute;right: 0;top: 17px">{{ suffixDomaine }}</div>
                                <mat-hint *ngIf="f['Domaine'].touched && f['Domaine'].invalid" class="m-b-16 error-msg">
                                    <div class="text-error" *ngIf="f['Domaine'].errors && f['Domaine'].errors['required']">
                                        Le domaine est requis
                                    </div>
                                </mat-hint>
                            </mat-form-field>
                            <ng-container *ngIf="f.Interface.value == CLU_MOBILE_INTERFACE.FRONTOFFICE">
                                <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">ID Site</mat-label>
                                <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <input matInput formControlName="CodeSite" />
                                    <mat-hint *ngIf="f['CodeSite'].touched && f['CodeSite'].invalid" class="m-b-16 error-msg">
                                        <div class="text-error" *ngIf="f['CodeSite'].errors && f['CodeSite'].errors['required']">
                                            L'identifiant du site est requis
                                        </div>
                                    </mat-hint>
                                </mat-form-field>
                            </ng-container>
                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Nom d'utilisateur</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput formControlName="Username" />
                                <mat-hint *ngIf="f['Username'].touched && f['Username'].invalid" class="m-b-16 error-msg">
                                    <div class="text-error" *ngIf="f['Username'].errors && f['Username'].errors['required']">
                                        Le nom d'utilisateur est requis
                                    </div>
                                </mat-hint>
                            </mat-form-field>
                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block" >Mot de passe</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="password" formControlName="Password" #passwordField/>
                                <mat-hint *ngIf="f['Password'].touched && f['Password'].invalid" class="m-b-16 error-msg">
                                    <div class="text-error" *ngIf="f['Password'].errors && f['Password'].errors['required']">
                                        Le mot de passe est requis
                                    </div>
                                </mat-hint>
                                <button mat-icon-button type="button" (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'" matSuffix>
                                    <i-tabler *ngIf="passwordField.type === 'password'" name="eye" class="icon-20 d-flex"></i-tabler>
                                    <i-tabler *ngIf="passwordField.type === 'text'" name="eye-off" class="icon-20 d-flex"></i-tabler>
                                </button>
                            </mat-form-field>
                            <div class="error-container" *ngIf="!!errorText">{{ errorText }}</div>
                            <button mat-flat-button color="primary" class="w-100" [disabled]="!form.valid || loading">
                                <ng-container *ngIf="loading"><mat-spinner diameter="25"></mat-spinner></ng-container>
                                <ng-container *ngIf="!loading">Se connecter</ng-container>
                            </button>
                            <ng-container *ngIf="!!appVersion">
                                <button mat-button type="button" class="w-100" [cdkCopyToClipboard]="appVersion.APP_VERSION_ID + ' | ' + appVersion.APP_VERSION_DISPLAY + ' | ' + appVersion.APP_COMMIT_SHA">
                                    {{ appVersion.APP_VERSION_ID + ' | ' + appVersion.APP_VERSION_DISPLAY }}
                                </button>
                                <ng-container *ngIf="!!appVersion.DEVICE_ID">
                                  <button mat-button type="button" class="w-100" [cdkCopyToClipboard]="appVersion.DEVICE_ID">
                                      DEVICE | {{ appVersion.DEVICE_ID }}
                                  </button>
                                </ng-container>
                            </ng-container>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
